import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
const REVIEWS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/YP30k_u7fBp15AsfUvFQEXkcYSPiRak1qVO1lsfmZBzfMTpFtgG7EusPp9oru_abc94YZ6lBWI5wxOR0KSyLZokFbYHBWzEjruQyf9We7WavEfEed3FPuq4rD_4WmprI.jpg?v=1778629864';
const CHAT_IMAGES = ['https://cdn.shopify.com/s/files/1/0661/3847/2542/files/chat_1.png?v=1779851652', 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/ChatGPT_Image_26_may_2026_11_03_23_p.m..png?v=1779851653', 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/ChatGPT_Image_26_may_2026_10_55_45_p.m..png?v=1779851653', 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/chat_4.png?v=1779975033'];
export function Reviews() {
  return <section className="relative py-20 px-4 md:px-6 overflow-hidden" data-id="element-386">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-387">
        <img src={REVIEWS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-388" />
        <div className="absolute inset-0 bg-cosmic-black/65" data-id="element-389" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.4) 30%, rgba(5,5,8,0.4) 70%, #050508 100%)'
      }} data-id="element-390" />
      </div>

      <div className="relative z-10 container mx-auto max-w-7xl" data-id="element-391">
        <AnimatedSection data-id="element-392">
          <h2 className="md:text-5xl font-serif font-bold text-center text-white mb-4 text-[36px] md:text-[44px]" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.95)'
        }} data-id="element-393">
            Pensaron que era astrología… hasta que entraron
          </h2>
          <p className="text-center mb-12 md:mb-16 text-[#E4BE36] font-serif italic text-base md:text-lg" style={{
          textShadow: '0 2px 15px rgba(0,0,0,0.95)'
        }} data-id="element-394">
            Algunas conversaciones después de descubrir LOS 12.
          </p>
        </AnimatedSection>

        {/* Chat screenshots — 4 side-by-side on desktop, 2x2 on mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-5" data-id="element-395">
          {CHAT_IMAGES.map((src, index) => <motion.div key={src} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          delay: index * 0.12,
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} whileHover={{
          y: -4
        }} className="relative rounded-xl overflow-hidden" style={{
          border: '1px solid rgba(232,212,139,0.18)',
          boxShadow: '0 0 24px rgba(201,168,76,0.15), 0 12px 40px rgba(0,0,0,0.55)',
          background: 'rgba(8,8,14,0.4)'
        }} data-id="element-396">
              <img src={src} alt={`Conversación real ${index + 1} después de descubrir LOS 12`} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-397" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}